module.exports = __webpack_public_path__ + "media/hyper/images/favicon-6652e5a6daa5ce22183ece3412ed0729.ico";